/**
 * Utilidades y schema para valores de referencia.
 * Extraído del form dialog para evitar react-refresh warnings.
 */

import { z } from "zod";

// =============================================================================
// Age conversion constants and functions
// =============================================================================

export const DAYS_PER_YEAR = 365;

export function yearsToDays(years: number | undefined): number | undefined {
  return years != null ? Math.round(years * DAYS_PER_YEAR) : undefined;
}

export function daysToYears(days: number | undefined | null): number | undefined {
  return days != null ? Math.round((days / DAYS_PER_YEAR) * 100) / 100 : undefined;
}

// =============================================================================
// Zod schema
// =============================================================================

export const valorReferenciaBaseSchema = z.object({
  sexo: z.enum(["M", "F", "A"]).default("A"),
  edad_min_anios: z.coerce.number().min(0).optional(),
  edad_max_anios: z.coerce.number().min(0).optional(),
  valor_min: z.coerce.number().optional().nullable(),
  valor_max: z.coerce.number().optional().nullable(),
  valor_texto: z.string().optional().default(""),
  unidad: z.string().optional().default(""),
  descripcion: z.string().optional().default(""),
});

export const valorReferenciaFormSchema = valorReferenciaBaseSchema
  .refine(
    (data) => {
      if (data.edad_min_anios != null && data.edad_max_anios != null) {
        return data.edad_min_anios <= data.edad_max_anios;
      }
      return true;
    },
    { message: "validation.ageMinMax", path: ["edad_max_anios"] }
  )
  .refine(
    (data) => {
      if (data.valor_min != null && data.valor_max != null) {
        return data.valor_min <= data.valor_max;
      }
      return true;
    },
    { message: "validation.valueMinMax", path: ["valor_max"] }
  );

export type ValorReferenciaFormValues = z.infer<typeof valorReferenciaBaseSchema>;
